import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("cart") || "[]"));
  const [open, setOpen] = useState(false);

  useEffect(() => localStorage.setItem("cart", JSON.stringify(items)), [items]);

  const add = (p, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.id);
      if (ex) return prev.map((i) => (i.id === p.id ? { ...i, quantity: Math.min(i.quantity + qty, 50) } : i));
      return [...prev, { id: p.id, name: p.name, brand: p.brand, price: p.price, image: p.images?.[0], stock: p.stock, free_shipping: !!p.free_shipping, quantity: qty }];
    });
    setOpen(true);
  };
  const setQty = (id, q) =>
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, quantity: Math.max(1, Math.min(q, 50)) } : i)));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const shipping = items.length && items.every((i) => i.free_shipping) ? 0 : 18;

  return (
    <CartCtx.Provider value={{ items, add, setQty, remove, clear, total, count, shipping, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
